<template>
    <div class="card-video-inline">

        <!-- START GRID -->
        <div class="grid" data-grid="custom">

            <!-- start item -->
            <div data-item="c-11 r-11 / middle">
                <a class="thumb" :href="links.profile">
                    <img :src="images.middle.jpg" alt="">
                </a>
            </div>
            <!-- end item -->

            <!-- start item -->
            <div data-item="c-21 r-11 / middle">&nbsp;</div>
            <!-- end item -->

            <!-- start item -->
            <div data-item="c-31 r-11 / middle">
                <div class="h5 weight-400">
                    <a :href="links.profile">{{ title }}</a>
                </div>
                <div class="h6 actors" v-if="actor">
                    <a :href="actor.links.profile">
                        <span>{{ actor.name }}</span>
                    </a>
                    <span v-if="network">{{ $t('notification_from') + ' ' + network.name }}</span>
                </div>
                <div class="h6 channel" v-else>
                    <a :href="channel.links.profile">
                        <span>{{ channel.name }}</span>
                    </a>
                    <span v-if="network">{{ $t('notification_from') + ' ' + network.name }}</span>
                </div>
                <div class="h6 calendar-data m-hide">{{ date }}</div>
            </div>
            <!-- end item -->

            <!-- start item -->
            <div data-item="c-41 r-11 / middle center">
                <button class="btn transparent small nowrap" :title="$t('btn_remove')" @click="$emit('dismiss')">
                    <svg class="icon solo" v-lazysvg data-src="/images/icon/close.svg#icon"></svg>
                </button>
            </div>
            <!-- end item -->

        </div>
        <!-- END GRID -->

    </div>
</template>

<script>
    export default {
        name: 'NotificationsItem',

        props: {
            id: Number,
            title: String,
            images: Object,
            links: Object,
            actor: Object,
            network: Object,
            channel: Object,
            date: String,
        },
    }
</script>
